// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"b23a892adc28cadd","3550":"085c5bf262e7f4ca","4649":"fffabcb86dc50ebd"}[chunkId] + ".css";
};